import { useQuery } from '@tanstack/react-query';

import { sandboxQueryKey } from '@/api/queryKeys';
import { api } from '@/lib/api-client';
import type { PaginationResponse } from '@/models/pagination';
import type { Sandbox } from '@/models/sandbox';

export const getSandboxes = async ({ game_code }: { game_code: string }) => {
  const response = await api.get<{ sandboxes: Sandbox[] } & PaginationResponse>(
    `/v1/sandboxes?game_code=${game_code}&sort_by=created_at&sort_order=asc&limit=50`,
  );
  return response.data;
};

export const getSandboxesQueryOptions = ({
  game_code,
}: {
  game_code: string;
}) => {
  return {
    queryKey: sandboxQueryKey.list(game_code),
    queryFn: () => getSandboxes({ game_code }),
  };
};
export const useGetSandboxes = ({ game_code }: { game_code: string }) => {
  return useQuery({
    ...getSandboxesQueryOptions({ game_code }),
    // No Game picked yet: nothing to list.
    enabled: game_code !== '',
    select: (data) => ({
      ...data,
      sandboxes: [...data.sandboxes].sort((a, b) => {
        const retailCode = import.meta.env.VITE_ADMIN_SANDBOX_CODE;
        if (a.code === retailCode) return -1;
        if (b.code === retailCode) return 1;
        return 0;
      }),
    }),
  });
};
